import * as React from 'react';
import styled from 'styled-components';
import { useRange } from '../../../../utils/hooks/useRange';

interface IProgressBar {
  /** index of current slide */
  current: number;
  /** number of slides */
  count: number;
  run: boolean;
}

export const ProgressBar: React.FC<IProgressBar> = ({
  current,
  count,
  run,
}) => {
  const { items } = useRange({
    count: count,
  });

  return (
    <StyledProgressBar>
      {items.length ? (
        items.map((item, index) => {
          return (
            <StyledBarColumn key={`progress_bar_${index}`}>
              <ProgressBarItem
                current={current === index}
                beforeCurrent={index < current}
                run={run}
              />
            </StyledBarColumn>
          );
        })
      ) : (
        <StyledPlaceholderBar />
      )}
    </StyledProgressBar>
  );
};

const StyledProgressBar = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 3px;
  margin-bottom: 20px;
  overflow: hidden;
`;

const StyledBarColumn = styled.div`
  width: 100%;
  position: relative;
  margin-right: 2px;
  background: rgb(255, 255, 255, 0.4);

  &:last-child {
    margin-right: 2px;
  }
`;

const StyledPlaceholderBar = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  margin-right: 2px;
  background: rgb(255, 255, 255, 0.4);
`;

const ProgressBarItem: React.FC<{
  run: boolean;
  beforeCurrent: boolean;
  current: boolean;
}> = ({ run, beforeCurrent, current }) => {
  return (
    <StyledBar
      className={beforeCurrent ? 'before-current' : run && current ? 'run' : ''}
    />
  );
};

const StyledBar = styled.div`
  position: absolute;
  left: 0;
  height: 100%;
  background: white;

  &.before-current {
    width: 100%;
  }

  &.run {
    animation: loader 3.5s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }

  @keyframes loader {
    0% {
      width: 0%;
      left: 0;
      right: 0;
    }
    100% {
      width: 100%;
      left: 0;
      right: 0;
    }
  }
`;
